<template>
  <v-select
    v-model="option"
    :class="[
      'select pa-0',
      isSelectOpen ? 'select--open' : 'select--closed',
      item.isEditable ? 'select--editable' : '',
      invalid ? 'error' : ''
    ]"
    :disabled="disabled"
    :items="options"
    :label="placeholder"
    :menu-props="{ bottom: true, offsetY: true }"
    hide-details="auto"
    item-text="name"
    item-value="value"
    solo
    @blur="isSelectOpen = false"
    @change="handleOptionChange"
    @focus="isSelectOpen = true"
  ></v-select>
</template>

<script>
export default {
  name: "CommonSelectButton",
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    changeValue: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    item: {
      type: Object,
      required: true
    },
    invalid: {
      type: Boolean,
      required: false
    }
  },
  data: instance => ({
    option: instance.options[0],
    isSelectOpen: false
  }),
  created() {
    this.option = this.value;
  },
  methods: {
    handleOptionChange(value) {
      this.changeValue && this.changeValue(value);
    }
  },

  watch: {
    item: {
      handler: function(newValue) {
        this.option = newValue.fanType;
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.select {
  max-width: 75px;
  padding: 0 !important;
}

.select >>> .v-input__slot {
  box-shadow: none !important;
  font-size: 14px;
  padding: 0 !important;
  background-color: var(--content-bg-color) !important;
}

.select--editable >>> .v-input__slot {
  background-color: var(--white-color) !important;
}

.select >>> .v-select__selections {
  display: flex;
  justify-content: flex-end;
}

.select >>> .v-select__selections input {
  display: none !important;
}

.select >>> .v-select__selection {
  color: var(--primary-color);
}

.select--closed >>> .v-select__selection:hover {
  cursor: pointer;
}

.select >>> .v-input__append-inner {
  display: none;
}

.select >>> .v-input__control {
  min-height: 20px;
}

.select.error >>> .v-label {
  font-size: 13px;
  color: var(--red-color) !important;
}

.select >>> .v-label {
  font-size: 13px;
  color: var(--grey-color) !important;
}
</style>
